<template>
  <div class="hidden-print d-print-none">
    <div class="actionbar">
      <div class="container row-xs">
        <!-- Breadcrumb -->
        <div class="actionbar-breadcrumb hidden-xs hidden-ms">
          <ol class="breadcrumb visible-sm">
            <template v-for="(item, index) in breadcrumb">
              <li
                v-if="showOrNot(index)"
                class="truncate"
                style="max-width: 120px;"
                :key="index"
              >
                <div v-if="item.page">
                  <router-link
                    v-if="clickOrNot(item, index)"
                    :to="{ name : item.page }"
                  >{{ showName(item,index) }}</router-link>
                  <span v-if="clickOrNot(item,index)">{{ showName(item,index) }}</span>
                </div>
                <span
                  v-if="!item.page"
                  class="text-muted"
                >{{ item.name }}</span>
              </li>
            </template>
          </ol>
          <ol class="breadcrumb visible-md">
            <li
              v-if="!breadcrumb.length > 3"
              class="truncate"
              style="max-width: 120px;"
            >
              <a @click="navigateToFrontPage">Forside</a>
            </li>
            <template v-for="(item, index) in breadcrumb">
              <li
                v-if="index > 1 && breadcrumb.length > 3"
                class="truncate"
                style="max-width: 120px;"
                :key="index"
              >
                <router-link
                  v-if="item.page"
                  :to="{ name : item.page }"
                >{{ item.name }}</router-link>
                <span
                  v-if="!item.page"
                  class="text-muted"
                >{{ item.name }}</span>
              </li>
            </template>
          </ol>
          <ol class="breadcrumb visible-lg">
            <li
              class="truncate"
              style="max-width: 120px;"
            >
              <a @click="navigateToFrontPage">Forside</a>
            </li>
            <li
              v-for="(item, index) in breadcrumb"
              class="truncate"
              style="max-width: 120px"
              :key="index"
            >
              <router-link
                v-if="item.page"
                :to="{ name : item.page }"
              >{{ item.name }}</router-link>
              <span
                v-if="!item.page"
                class="text-muted"
              >{{ item.name }}</span>
            </li>
          </ol>
        </div>
        <!-- Department picker -->
        <div
          class="actionbar-actions dropdown pull-right"
          v-if="isChainUser()"
          data-bind="css : departmentPickerClass "
        >
          <button
            role="button"
            type="button"
            class="btn btn-default btn-dark dropdown-toggle truncate"
            data-toggle="dropdown"
            style="color: white;"
          >
            <span>{{ currentSiteName() }}</span>
            <span class="caret"></span>
          </button>

          <div class="dropdown-menu">
            <a
              v-for="department in departments"
              @click="setCurrentSite(department)"
              role="button"
              class="list-group-item list-group-item-primary list-group-item-sm"
              :class="{ 'list-group-item-secondary': department.SiteId !== CONFIG.user.CurrentSiteId }"
              :key="department.SiteId"
            >{{ department.SiteName }}</a>
          </div>
        </div>
        <div
          v-if="!(true || isChainUser())"
          class="actionbar-actions pull-right"
        >
          <ol class="breadcrumb visible-sm visible-md visible-lg">
            <li class="truncate">{{ currentSiteName() }}</li>
          </ol>
        </div>
        <!-- Action buttons -->
        <div class="actionbar-actions">
          <button
            :disabled="!(breadcrumb.length > 1)"
            @click="$router.go(-1)"
            class="btn btn-default btn-dark pull-left"
            role="button"
            type="button"
          >
            <span class="glyphicon glyphicon-chevron-left"></span>
            <span style="color: white;">Tilbake</span>
          </button>
        </div>
        <div
          class="actionbar-actions"
          data-bind="actions: actions"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    CONFIG: window.CONFIG,
    departments: window.CONFIG.departments || []
  }),
  computed: {
    breadcrumb () {
      return this.$store.getters['breadcrumbs/getItems']
    }
  },
  methods: {
    showOrNot (index) {
      return this.breadcrumb.length > 3 && index >= this.breadcrumb.length - 3
    },
    clickOrNot (element, index) {
      return this.breadcrumb.length > 3
        ? index === this.breadcrumb.length - 2
        : true
    },
    showName (element, index) {
      return this.breadcrumb.length > 3
        ? index === this.breadcrumb.length - 2
          ? element.name
          : index === this.breadcrumb.length - 3
            ? '...'
            : ''
        : element.name
    },
    navigateToFrontPage () {
      window.location = this.CONFIG.fixitOnlineUrl
    },
    isChainUser () {
      let hasRole = false
      window.CONFIG.user.UserRoles.forEach(function (role) {
        if (role.RoleName === 'ChainUser') hasRole = true
      })
      return hasRole && window.CONFIG.user.SiteList.length > 1 // if ChainUser and chain has multiple sites.
    },
    async setCurrentSite (site) {
      if (site.SiteId !== window.CONFIG.user.CurrentSiteId) {
        let siteChanged = await this.$store.dispatch(
          'global/setCurrentSiteId',
          { siteId: site.SiteId }
        )
        if (siteChanged) location.reload()
      }
    },
    currentSiteName () {
      return this.CONFIG.departments.filter(function (d) {
        return d.SiteId === window.CONFIG.user.CurrentSiteId
      })[0].SiteName
    }
  }
}
</script>
